import React, { useContext, useState } from 'react';
import { View, Text, Pressable } from 'react-native';
import styled from 'styled-components/native';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';

import secrets from 'app/secrets';
import EditFeeMarkups from 'app/src/components/Accounting/FeeMarkups';
import DataState from 'app/src/components/DataState';
import AuthContext from 'app/src/contexts/AuthContext';
import Modal from 'app/src/elements/Modal';
import { currency } from 'app/src/utils/stringHelpers';

const Label = styled(Text)`
  font-weight: 600;
`;

const amountData = feeMarkup => {
  if ('percent' === feeMarkup.markupType) {
    return `${feeMarkup.amount}%`;
  } else {
    return `${currency(feeMarkup.amount)}`;
  }
};

const FeeMarkups = ({ seller, refetch }) => {
  const { feeTypes, settings} = useContext(AuthContext);
  const [showEditModal, setShowEditModal] = useState(false);

  if (!secrets.app.doubleEntry) { return null; }

  if (!settings || !seller) { return <DataState.Loading />; }

  const feeMarkups = feeTypes.map(feeType => (
    seller.feeMarkups.find(entry => entry.feeType === feeType.name) ||
      settings.feeMarkups.find(entry => entry.feeType === feeType.name) ||
      {
        feeType: feeType.name,
        markupType: 'percent',
        amount: '0',
        defaultMarkup: true
      }
  ));

  return (
    <>
      <View style={{ flexDirection: 'row', gap: 10 }}>
        <Label>Fee Markups</Label>
        <Pressable
          onPress={() => setShowEditModal(true)}
          style={{display: 'inline-block'}}
        >
          <FontAwesomeIcon icon={faEdit} title="Edit" />
        </Pressable>
      </View>

      <Text style={{ marginBottom: 6 }}>(* = uses system default)</Text>

      {feeMarkups.map(feeMarkup => (
        <View key={feeMarkup.feeType} style={{ flexDirection: 'row' }}>
          <Label>{feeMarkup.feeType}: </Label>
          <Text>
            {amountData(feeMarkup)}
            {feeMarkup.defaultMarkup && '*'}
          </Text>
        </View>
      ))}

      {showEditModal &&
        <Modal
          showModal
          setShowModal={show => { setShowEditModal(show); refetch(); }}
          modalType="Fee Markups"
        >
          <EditFeeMarkups
            seller={seller}
            sellerFeeMarkups={feeMarkups}
            refetch={() => { setShowEditModal(false); refetch(); }}
          />
        </Modal>
      }
    </>
  );
};

export default FeeMarkups;
